import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, output, Type, ViewEncapsulation } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatList, MatListItem, MatListItemIcon, MatListItemTitle } from '@angular/material/list';
import { TbListItem } from '../../../modules/fidelity-app/fidelity-app.types';

@Component({
    selector: 'tb-items-list',
    imports: [
        MatList,
        MatListItem,
        MatRipple,
        MatIcon,
        MatDivider,
        MatListItemIcon,
        MatListItemTitle,
        NgTemplateOutlet,
    ],
    templateUrl: './tb-items-list.component.html',
    styleUrl: './tb-items-list.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class TbItemsListComponent {
    items = input.required<TbListItem[]>();
    topItemsList = computed<TbListItem[]>(() => this.items().filter((item) => !item.alignBottom));
    bottomItemsList = computed<TbListItem[]>(() => this.items().filter((item) => item.alignBottom));

    itemClicked = output<Type<any>>();
}
